/* eslint-disable no-shadow */
export enum SearchConsoleAccountsQueryKeys {
  GetAll = 'accountsSearchConsole/getAll',
  GetOneById = 'accountsSearchConsole/getOneById',
  GetOAuthUrl = 'accountsSearchConsole/getOAuthUrl',
  Create = 'accountsSearchConsole/create',
  AddCredentials = 'accountsSearchConsole/addCredentials',
  Update = 'accountsSearchConsole/update',
  Autocomplete = 'accountsSearchConsole/autocomplete',
  Breadcrumb = 'accountsSearchConsole/breadcrumb',
  Delete = 'accountsSearchConsole/delete',
  RevokeOAuth2Token = 'accountsSearchConsole/revokeOAuth2Token'
}

export enum SearchConsoleAccountsOTPQueryKeys {
  Add = 'accountsSearchConsoleOTP/add',
  Delete = 'accountsSearchConsoleOTP/delete',
  GetCode = 'accountsSearchConsoleOTP/getCode'
}
